import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { creditCardAction, creditCardActionFSPay, creditcardTransactionAction, creditCardPaymentEclipseOpsAction } from "@mobile-dev/platform/common/redux/actions/CreditCardAction";
import ErrornDialog from "../../../../Common/ErrorDialog/ErrorDialog";
import Loader from "../../../../Common/Loader";
import TransactionDialog from "../../../../Common/TransactionDialog";
import BilledHeader from "../BilledHeader";
import { AppConstatnt, CREDIT_CARD } from "../../../../../Utils/AppConstant";
import { useHistory, useLocation } from "react-router";
import { Alert } from "react-bootstrap";
import { darkStyles, lightStyles } from "../../../../../Utils/CreditCardStyles";
import { getApplicationFlow, getCarrierEnteredMobileNumber, getControlNumber, getTheme, isEclipseOpsTruck, showAlert } from "../../../../../Utils/Utility";
import { toast } from "react-toastify";
import { countryList } from "../../../../../Utils/CountryCode";
import { errorCodes } from "../../../../../Utils/PaytraceErrorCode";
import { clearError } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import { injectIntl } from 'react-intl';
import moment from "moment";


function CreditCard({ intl, ...props }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const [paymentInstance, setInstance] = useState(null);
    const [transactionId, setTransactionId] = useState(null);
    const [failedTransactionId, setfailedTransactionId] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [responseCode, setResponseCode] = useState(null);
    const PTPayment = window.PTPayment;
    const res = useSelector(state => state.creditCard.creditDetails);
    const transactionStatus = useSelector(state => state.creditCard.creditCardTransaction);
    const loading = useSelector(state => state.creditCard.loading);
    const amount = location.state.amount;
    const originalAmount = location?.state?.originalAmount;
    const remainingAmount = location.state.remainingAmount;
    const selection = location.state.selection;
    const loadId = location.state.id;
    const paymentmethods = location.state.paymentmethods;
    const invoice_id = getControlNumber();
    const total_bill_amount = location.state.total_bill_amount;
    const errorStatus = useSelector(state => state.creditCard.error);
    const [show, setShow] = useState(false);
    const history = useHistory();
    const [isError, setError] = useState(false);
    let theme = getTheme();
    const [styles, setStyles] = useState(theme === 'light' ? lightStyles : darkStyles);
    //const [theme, setTheme] = useState(getTheme());
    const [billing_address, setBillingDetails] = useState({ name: '', street_address: '', city: '', state: '', zip: '' });
    const [value, setValue] = useState('US');
    const id = location.state.id;
    const { formatMessage } = intl;
    const loads = useSelector(state => state.billed.billedPo.loads);
    const load = loads.find(load => load.load_id === id);
    const warehouse_id = load?.warehouse_id;
    const auth = useSelector(state => state.amplifyUser);
    const serviceFee = location.state.serviceFee;
    let driver_phone = getApplicationFlow() === 'Carrier' ? getCarrierEnteredMobileNumber() : auth?.user?.attributes.phone_number;

    useEffect(() => {
        if (isEclipseOpsTruck(load)) {
            dispatch(creditCardActionFSPay(driver_phone))
        } else {
            dispatch(creditCardAction());
        }
    }, []);

    useEffect(() => {
        dispatch(clearError());
    }, []);



    useEffect(() => {
        if (res) {

            if (theme === AppConstatnt.theme.DARK) {
                setStyles(darkStyles);
            }
            else if (theme === AppConstatnt.theme.LIGHT) {

                setStyles(lightStyles);
            }

        }

    }, [theme]);

    function ptPaymentSetup() {

        if (res) {
            PTPayment.setup({
                styles,
                authorization: { clientKey: res }
            }).then(function (instance) {
                //use instance object to process and tokenize sensitive data payment fields.
                PTPayment.getControl("creditCard").label.text(formatMessage({ id: "credit_card_number" }));
                PTPayment.getControl("expiration").label.text(formatMessage({ id: "app.expiration" }))
                PTPayment.getControl("securityCode").label.text(formatMessage({ id: "app.security_code" }))

                setInstance(instance);
            });
        }
    }

    useEffect(() => {
        let key = null;
        let errorCodeExist;

        if (transactionStatus && transactionStatus.response_code === 101) {
            setTransactionId(transactionStatus.transaction_id);
            setfailedTransactionId(null);
            setError(false);
        }

        else if (errorStatus) {

            if (errorStatus?.response?.data.response_code === 102) {
                setTransactionId(null);
                setSubmitted(false);
                setError(false);
                showAlert(toast.TYPE.ERROR, `${errorStatus?.response?.data.approval_message}, please try again. Thank you. For assistance, please contact our support center (855) 752-2878`);
            }
            else if (errorStatus?.response?.data?.errors) {
                errorCodeExist = Object.keys(errorStatus?.response?.data?.errors).some(e => {
                    key = e;
                    return errorCodes.includes(e)
                });
                if (errorCodeExist) {
                    ptPaymentSetup();
                    showAlert(toast.TYPE.WARNING, errorStatus?.response?.data.errors[key][0]);
                    setSubmitted(false);
                }
                else {
                    ptPaymentSetup();
                    setSubmitted(false);
                    setError(true);
                }


            }
            else {
                ptPaymentSetup();
                setSubmitted(false);
                setError(true);
            }

        }
    }, [transactionStatus, errorStatus]);


    useEffect(() => {
        if (res) {
            PTPayment.setup({
                styles,
                authorization: { clientKey: res }
            }).then(function (instance) {
                //use instance object to process and tokenize sensitive data payment fields.
                PTPayment.getControl("creditCard").label.text(formatMessage({ id: "app.credit_card_number" }));
                PTPayment.getControl("expiration").label.text(formatMessage({ id: "app.expiration" }))
                PTPayment.getControl("securityCode").label.text(formatMessage({ id: "app.security_code" }))
                setInstance(instance);
            });
        }
    }, [res, intl.locale]);

    const onShowAlert = () => {
        setShow(true)
        window.setTimeout(() => {
            setShow(false)
        }, 10000)

    }



    const handleChange = (e) => {
        setBillingDetails({
            ...billing_address,
            [e.target.name]: e.target.value
        });

    }

    const changeHandler = (e) => {
        setValue(e.target.value);
    }

    const handlePayment = () => {

        PTPayment.validate(function (validationErrors) {
            if (validationErrors.length >= 1) {
                if (validationErrors[0]['responseCode'] == '35') {
                    // Handle validation Errors here
                    // This is an example of using dynamic styling to show the Credit card number entered is invalid
                    PTPayment.style({ 'cc': { 'border_color': 'red' } });
                    setErrorMessage(validationErrors);
                    onShowAlert();

                }
                else if (validationErrors[0]['responseCode'] == '43') {
                    setErrorMessage(validationErrors);
                    onShowAlert();
                    PTPayment.style({ 'exp': { 'border_color': 'red' } })
                }
                else if (validationErrors[0]['responseCode'] == '44') {
                    setErrorMessage(validationErrors);
                    onShowAlert();

                }
                else if (validationErrors[0]['responseCode'] == '148') {
                    setErrorMessage(validationErrors);
                    onShowAlert();
                    PTPayment.style({ 'code': { 'border_color': 'red' } })
                }
                setSubmitted(false);

            } else {
                // no error so tokenize
                paymentInstance.process()
                    .then((r) => {
                        billing_address.country = value;
                        const request = { ...r.message, amount: amount, load_id: loadId, integrator_id: '956063aFhExE', billing_address, invoice_id }
                        if (isEclipseOpsTruck(load)) {
                            const transactionData = {
                                recID: loadId,
                                transactionType: "WEB_CREDIT_CARD",
                                driverLastName: auth?.user?.attributes?.family_name,
                                driverFirstName: auth?.user?.attributes?.given_name,
                                carrierName: "",
                                fullAmount: amount,
                                driverPhoneNumber: driver_phone,
                                user_number: driver_phone,
                                transactionDateTime: moment(),
                                timeZone: "UTC+6",
                                unitNum: null,
                                tripNum: null,
                                relaySiteId: warehouse_id,
                                tabletype: "eclipseOps",
                                serviceFee: serviceFee,
                                paymentType: selection,
                                billing_address: billing_address,
                                ...r.message
                            }
                            dispatch(creditCardPaymentEclipseOpsAction(transactionData))
                        } else {
                            dispatch(creditcardTransactionAction(request))

                        }

                        setSubmitted(false);
                        ptPaymentSetup();
                    })
                    .catch((err) => {

                        PTPayment.reset();
                        setSubmitted(false);
                    });
            }
        });// end of PTPayment.validate

    }

    const getAmount = () => {
        if (isEclipseOpsTruck(load)) {
            return parseFloat(amount) - parseFloat(serviceFee)
        } else {
            return originalAmount
        }
    }



    return (
        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <BilledHeader path={`/paymentconfirmation/${id}`} amount={getAmount()} remainingAmount={remainingAmount} selection={selection} total_bill_amount={total_bill_amount} paymentmethods={paymentmethods} />
                    <div className="container_block" style={{ padding: '40px' }}>
                        <div id="smartwizard" className="sw sw-theme-dots sw-justified">
                            <div className="row">
                                {show &&
                                    <div className="col-md-8">
                                        <Alert variant="danger" onClose={() => setShow(false)} dismissible >
                                            {errorMessage.length > 1 ? "Please Enter the correct value" : errorMessage[0].description}
                                        </Alert>
                                    </div>
                                }
                                <div className="col-md-6">

                                    <div id="pt_hpf_form" />

                                    <div className="form-group col-md-10">
                                        <label htmlFor="nameOnCard">{formatMessage({ id: "app.name_on_card" })}</label>
                                        <input type="text" name="name" id="nameOnCard" className="form-control form-control-sm" style={{ backgroundColor: 'transparent', paddingLeft: '5px' }} placeholder="" onChange={handleChange} required />
                                    </div>
                                    <div className="form-group col-md-10">
                                        <label htmlFor="streetAddress">{formatMessage({ id: "app.billing_address" })}</label>
                                        <input type="text" name="street_address" id="street_address" className="form-control form-control-sm" style={{ backgroundColor: 'transparent', paddingLeft: '5px' }} placeholder="" onChange={handleChange} required />
                                    </div>
                                    <div className="form-group col-md-10">
                                        <label htmlFor="city">{formatMessage({ id: "app.city" })}</label>
                                        <input type="text" name="city" id="city" className="form-control form-control-sm" style={{ backgroundColor: 'transparent', paddingLeft: '5px' }} placeholder="" onChange={handleChange} />
                                    </div>
                                    <div className="form-group col-md-10">
                                        <label htmlFor="state">{formatMessage({ id: "app.state" })}</label>
                                        <input type="text" name="state" id="state" className="form-control form-control-sm" style={{ backgroundColor: 'transparent', paddingLeft: '5px' }} placeholder="" onChange={handleChange} />
                                    </div>
                                    <div className="form-group col-md-10">
                                        <label htmlFor="zip">{formatMessage({ id: "app.billing_zip" })}</label>
                                        <input type="text" name="zip" id="zip" className="form-control form-control-sm" style={{ backgroundColor: 'transparent', paddingLeft: '5px' }} placeholder="" onChange={handleChange} required />
                                    </div>
                                    <div className="form-group col-md-10">
                                        <label htmlFor="country">{formatMessage({ id: "app.country" })}</label>
                                        <select className="form-control form-control-sm" value={value} onChange={changeHandler}>
                                            {countryList.map(country => {
                                                return (
                                                    <option value={country.code}>{country.name}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row">

                                {(transactionId || transactionStatus?.status == 'closed') && <TransactionDialog
                                    load_control_num={invoice_id}
                                    transactionId={transactionId}
                                    open
                                    id={props.match.params.id}
                                    paymentType={AppConstatnt.CREDIT_CARD}
                                    message={formatMessage({ id: "app.view_payment_details" })}
                                    amount={amount}
                                    remainingAmount={remainingAmount}
                                    selection={selection}
                                    total_bill_amount={total_bill_amount}
                                />}

                            </div>
                            <div className="toolbar toolbar-bottom pd-0" role="toolbar" style={{ textAlign: "right" }}>
                                {!loading &&
                                    <button className="btn sw-btn-next btn-chartreuse float-right" onClick={handlePayment}>{formatMessage({ id: "app.submit" })}</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading && <Loader />}
            {isError && <ErrornDialog
                error="Sorry you are experiencing an unknown issue. For immediate assistance, please contact our Contact Support Center at (855)752-2878 to speak with an agent. Thank you."
                open
            />}
        </div>
    )

}

export default injectIntl(CreditCard);